<template>
	<div class="rtc-private-acceptor">
		<div class="acceptor-container">
			<div class="acceptor-eyebrow">{{ modeText }}来电</div>
			<div class="avatar-section">
				<div class="avatar-container">
					<head-image :id="safeFriend.id" :name="callerName" :url="safeFriend.headImage" :size="80"
						:isShowUserInfo="false" radius="50%"></head-image>
					<div class="avatar-pulse"></div>
				</div>
			</div>
			
			<div class="info-section">
				<div class="caller-name">{{ callerName }}</div>
				<div class="call-type">{{ modeText }}通话邀请</div>
				<div class="call-status">{{ callerHintText }}</div>
			</div>
			
			<div class="button-section">
				<div class="action-buttons">
					<button type="button" class="call-action-btn reject-btn" @click="$emit('reject')" title="拒绝">
						<i class="call-action-icon el-icon-close"></i>
						<span class="call-action-label">拒绝</span>
					</button>
					<button type="button" class="call-action-btn accept-btn" @click="$emit('accept')" title="接受">
						<i class="call-action-icon el-icon-phone-outline"></i>
						<span class="call-action-label">接听</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "rtcPrivateAcceptor",
	components: {
		HeadImage
	},
	props: {
		mode: {
			type: String
		},
		friend: {
			type: Object
		}
	},
	computed: {
		safeFriend() {
			return this.friend || {};
		},
		callerName() {
			return this.safeFriend.showNickName || this.safeFriend.nickName || this.safeFriend.userName || '当前联系人';
		},
		modeText() {
			return this.mode == "video" ? "视频" : "语音"
		},
		callerHintText() {
			if (!this.safeFriend.id) {
				return '联系人信息同步中，接听后将进入当前通话窗口。';
			}
			return `等待你接听，接听后将进入${this.modeText}通话窗口。`;
		}
	}
}
</script>

<style scoped lang="scss">
.rtc-private-acceptor {
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 10000;
	width: min(304px, calc(100vw - 24px));

	.acceptor-container {
		background: var(--im-card-bg-90, rgba(255,255,255,0.96));
		backdrop-filter: blur(16px);
		border-radius: 18px;
		padding: 22px 20px 18px;
		box-shadow: 0 18px 36px -28px rgba(var(--im-black-rgb), 0.32);
		border: 1px solid rgba(var(--im-black-rgb), 0.08);
		text-align: center;

		.acceptor-eyebrow {
			font-size: 11px;
			font-weight: 600;
			line-height: 1.2;
			letter-spacing: 0.04em;
			color: var(--im-text-color-light);
		}

		.avatar-section {
			margin: 14px 0 18px;

			.avatar-container {
				position: relative;
				display: inline-block;

				.avatar-pulse {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 98px;
					height: 98px;
					border-radius: 50%;
					background: rgba(var(--im-primary-rgb), 0.08);
					animation: pulse-ring 2.2s infinite;

					&::before {
						content: '';
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						width: 118px;
						height: 118px;
						border-radius: 50%;
						background: rgba(var(--im-primary-rgb), 0.05);
						animation: pulse-ring 2.2s infinite 0.55s;
					}
				}
			}
		}

		.info-section {
			margin-bottom: 20px;

			.caller-name {
				font-size: 20px;
				font-weight: 700;
				color: var(--im-text-color-primary);
				line-height: 1.3;
				margin-bottom: 6px;
			}

			.call-type {
				font-size: 14px;
				color: var(--im-text-color);
				margin-bottom: 8px;
				font-weight: 500;
			}

			.call-status {
				font-size: 13px;
				line-height: 1.6;
				color: var(--im-text-color-light);
			}
		}

		.button-section {
			.action-buttons {
				display: flex;
				justify-content: center;
				gap: 18px;

				.call-action-btn {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					min-width: 104px;
					height: 44px;
					padding: 0 16px;
					border-radius: 999px;
					border: 1px solid transparent;
					gap: 8px;
					align-items: center;
					background: transparent;
					cursor: pointer;
					transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;

					.call-action-icon {
						font-size: 18px;
					}

					.call-action-label {
						font-size: 13px;
						font-weight: 600;
						line-height: 1.2;
						color: var(--im-text-color-primary);
					}

					&:hover {
						transform: translateY(-1px);
					}

					&.reject-btn {
						color: var(--im-color-danger);
						background: rgba(var(--im-danger-rgb, 245, 108, 108), 0.1);
						border-color: rgba(var(--im-danger-rgb, 245, 108, 108), 0.16);
					}

					&.accept-btn {
						color: var(--im-color-success);
						background: rgba(var(--im-success-rgb, 76, 175, 80), 0.12);
						border-color: rgba(var(--im-success-rgb, 76, 175, 80), 0.18);
					}
				}
			}
		}
	}
}

@keyframes pulse-ring {
	0% {
		transform: translate(-50%, -50%) scale(1);
		opacity: 1;
	}
	100% {
		transform: translate(-50%, -50%) scale(1.3);
		opacity: 0;
	}
}

</style>
